// extracted by mini-css-extract-plugin
module.exports = {"subjectCard":"subjectInfoCard_subjectCard__Hqxyq","customerNumber":"subjectInfoCard_customerNumber__1J6fy"};